/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState_hbl = [
    {
        id: '',
        il_ocean_import_id: '',
        hbl: '',
        il_trade_partner_id_shipper: '',
        il_trade_partner_id_consignee: '',
        hbl_link: '',
        hbl_quantity: '',
        il_opus_volume_unit_id: '',
        pre_alert: '',
        isf: '',
        isf_link: '',
        hbl_release: '',
        customs: '',
        customs_hold: '',
        customs_other: '',
        arrival_notice: 'Waiting',
        arrival_notice_link: '',
        invoice: 'Pending',
        invoice_link: [],
        invoice_date: null,
        crdr: 'Pending',
        crdr_link: [],
        crdr_date: null,
    },
];

const oimHblUpdateSlice = createSlice({
    name: 'oimHblUpdateForm',
    initialState: initialState_hbl,
    reducers: {
        setHblFormData: (state, action) => {
            return action.payload;
        },
        setHblUpdateData: (state, action) => {
            const { id, newData } = action.payload;
            return state.map((item) => {
                if (item.id === id) {
                    return { ...item, ...newData };
                }
                return item;
            });
        },
        addHBL: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteHBL: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((hbl) => hbl.id !== idToDelete);
        },
    },
});

export const { setHblFormData, setHblUpdateData, addHBL, deleteHBL } = oimHblUpdateSlice.actions;
export default oimHblUpdateSlice.reducer;
